<!--
     <FieldRelated>
-->

<template>
  <div class="d-flex">
    <ChipList
      :item="{items: items_chips}"
    />
  </div>
</template>
  
<style lang="scss">
  .field_title_navigate{
    width: fit-content;
    display: flex;
  }
  .field_related_separator {
    white-space: break-spaces;
  }
</style>
  
<script>
  import QFields from '@/qunit/QFields';
  import Navegation from '@/utils/Navegation';
  import ChipList from '@/components/explorer/chips/ChipList';

  export default {
    name: 'FieldRelated',
  
    components: {
      Field: () => import('./Field.vue'),
      ChipList,
    },

    props: {
      field: { required: true },
      short: { type: Boolean, default: false },
      is_mobile: { type: Boolean, default: false },
    },
  
    computed: {
      items_chips() {
        let items = (this.field.props.readable || []).map((itm, index) => ({
          component: 'ChipGeneric',
          value: (this.field.props.value|| [])[index],
          name: 'related_'+(this.field.props.value|| [])[index],
          readableValue: itm,
          hide_text: true,
          hide_icon: true,
        }));
        // Extra chip, the one giving the number of chips not shown
        const n_items = this.field.props.cols * 4;
        if (items.length > n_items) {
          const length = items.length;
          items = items.slice(0,n_items)
          items.push({
            component: 'ChipGeneric',
            value: n_items,
            name: 'extra_related',
            readableValue: '+'+(length - n_items),
            hide_text: true,
            hide_icon: true,
            color: 'primary',
          });
        }
        return items;
      },
    },

    methods: {
      // TODO: erase this or make it work
      navigate_to(pos) {
        Navegation.goto_qunit_by_uid(this.$router, this.field.value[pos]);
      },
    },
  }
</script>